import AppButton from "@/components/structure/AppButton";
import AppLinkButton from "@/components/structure/AppLinkButton";
import { useAuth } from "@/contexts/AuthContext";
import { faUser, faUserShield } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router";

export default function LoginStatus() {
  const { user, loading, logout, isAuthenticated } = useAuth();

  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="flex items-center space-x-4">
        <span className="text-gray-300">Loading...</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="flex items-center">
        <AppButton onClick={ () => navigate('/login') } variant="secondary" className="ml-2 text-sm">
          <FontAwesomeIcon icon={faUser} className="mr-2" />
          Sign In
        </AppButton>
      </div>
    );
  }

  let displayName =
    (user?.firstName &&
      user?.lastName &&
      `${user.firstName} ${user.lastName}`) ||
    user?.username ||
    user?.email;

  // override with pseudonym if available
  if (user?.pseudonym) {
    // let [first, ...last] = user.pseudonym.split(" ");
    // displayName = `${first} ${last}`;
    displayName = user.pseudonym;
  }

  const userIcon = user?.isProjectsAdmin ? faUserShield : faUser;

  return (
    <div className="flex items-center space-x-2 text-gray-300">
      <div className="mr-4 bg-gray-100 h-11 rounded-full pr-4 pb-0">
        <AppLinkButton
          variant="secondary"
          to="/profile"
          className="flex items-center"
        >
          {user?.avatarUrl ? (
            <img src={user.avatarUrl} className="mr-2 w-10 rounded-full" />
          ) : (
            <FontAwesomeIcon
              icon={userIcon}
              className="text-lg mr-2 w-5 rounded-full bg-gray-500 text-gray-100 p-3"
            />
          )}
          <b>{displayName}</b>
        </AppLinkButton>
      </div>

      <AppButton variant="outline" className="ml-2 text-sm" onClick={logout}>
        Sign Out
      </AppButton>
    </div>
  );
}
